import { FC } from 'react';
import { Dropdown, MenuProps } from 'antd';
import { Button } from '@dynamika-shared/ui/Button/Button';
import { QueryEvent } from '@restore/queries/queries.types';
import type { QueryCapabilities } from '@components/Queries/flow/queryFlow';
import ChevronIcon from '@dynamika-shared/ui/icons/Chevron';
import { QUERY_ACTION_MAP } from '@components/Queries/constants';


type ActionsControlProps = {
  onChange: (actionType: QueryEvent) => void;
  capabilities: QueryCapabilities;
};

export const ActionsControl: FC<ActionsControlProps> = ({
  onChange,
  capabilities,
}) => {
  const items: MenuProps['items'] = capabilities.availableEvents
    .filter(
      cap =>
        !cap.internal &&
        QUERY_ACTION_MAP?.[cap.event as keyof typeof QUERY_ACTION_MAP]
    )
    .map(cap => {
      const config =
        QUERY_ACTION_MAP?.[cap.event as keyof typeof QUERY_ACTION_MAP];
      return {
        label: (
          <div className='flex items-center gap-2'>
            <config.icon className='w-2 h-2' />
            <span className='text-1424 font-medium'>{config.label}</span>
          </div>
        ),
        key: cap.event,
        onClick: () => onChange(cap.event),
      };
    });

  return (
    <Dropdown
      menu={{ items }}
      trigger={['click']}
      className='flex items-center'
    >
      <Button
        className='!py-1.5 !px-4 rounded-[16px] font-semibold text-1624 flex items-center justify-center group !bg-waterLight hover:!bg-dodgerBlue hover:text-white'
        type='secondary'
        skipBasicStyles={true}
        iconPosition='end'
        icon={
          <ChevronIcon className='w-3 h-3 -rotate-90 group-hover:text-white transition-colors duration-200 ease-in-out' />
        }
      >
        <span className='group-hover:text-white transition-colors duration-200 ease-in-out'>
          Actions
        </span>
      </Button>
    </Dropdown>
  );
};
